import compliance from "../assets/compliance.svg";
import customer from "../assets/customer.svg";
import orders from "../assets/orders.svg";
import overview from "../assets/overview.svg";
import shoppingBag from "../assets/shopping-bag.svg";
import transactions from "../assets/transactions.svg";
import virtualAccount from "../assets/virtual-account.svg";
import wallet from "../assets/wallet.svg";
import welcome from "../assets/welcome.svg";
import mode from "../assets/mode.svg";
import settings from "../assets/settings.svg";
import audit from "../assets/audit.svg";
import rightarrow from "../assets/arrow-right.svg";

export const SidebarData = [
  {
    icon: welcome,
    heading: "Welcome",
  },
  {
    icon: compliance,
    heading: "Compliance",
  },
  {
    icon: overview,
    heading: "Overview",
  },
  // {
  //   headtext: 'Business'
  // },
  {
    icon: shoppingBag,
    heading: "products",
  },
  {
    icon: customer,
    heading: "customers",
  },
  {
    icon: orders,
    heading: "orders",
  },
  // {
  //   headtext: 'Business'
  // },
  {
    icon: wallet,
    heading: "wallets",
  },
  {
    icon: transactions,
    heading: "transactions",
  },
  {
    icon: virtualAccount,
    heading: "virtualAccount",
    
  },
];

export const SidebarDataII = [
  {
    icon: mode,
    heading: "Live mode",
  },
  {
    icon: settings,
    heading: "Settings",
  },
  {
    icon: audit,
    heading: "Audit logs",
  },
];

export const rightbarData = [
  {
    name: "Olaoluwa S.",
    amount: "#6,720.00",
    day: "Today, 8mins ago",
    icon: rightarrow,
  },
  {
    name: "Olaoluwa S.",
    amount: "#6,720.00",
    day: "13th Aug - 3:15pm",
    icon: rightarrow,
  },
  {
    name: "Olaoluwa S.",
    amount: "#6,720.00",
    day: "13th Aug - 3:15pm",
    icon: rightarrow,
  },
  {
    name: "Olaoluwa S.",
    amount: "#6,720.00",
    day: "13th Aug - 3:15pm",
    icon: rightarrow,
  },
  {
    name: "Olaoluwa S.",
    amount: "#6,720.00",
    day: "13th Aug - 3:15pm",
    icon: rightarrow,
  },

  //   {
  //     detail: "Ol",
  //   },
];
